import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { listActivity } from "@/lib/admin-extra.functions";
import { DataTable, type DataTableColumn } from "@/components/admin/DataTable";

export const Route = createFileRoute("/_authenticated/admin/activity")({
  component: ActivityPage,
});

type Row = {
  id: string;
  action: string;
  entity: string;
  entity_id: string | null;
  actor_email: string | null;
  detail: unknown;
  created_at: string;
};

function when(iso: string) {
  return new Date(iso).toLocaleString("en-ZA", { dateStyle: "medium", timeStyle: "short" });
}

function ActivityPage() {
  const fn = useServerFn(listActivity);
  const { data, isPending } = useQuery({ queryKey: ["admin", "activity"], queryFn: () => fn() });
  const rows = (data ?? []) as Row[];

  const columns: DataTableColumn<Row>[] = [
    { id: "created_at", header: "When", value: (r) => r.created_at, cell: (r) => when(r.created_at), sortable: true },
    { id: "action", header: "Action", value: (r) => r.action, sortable: true },
    { id: "entity", header: "Entity", value: (r) => r.entity, sortable: true },
    { id: "actor_email", header: "By", value: (r) => r.actor_email ?? "system" },
    {
      id: "detail",
      header: "Detail",
      value: (r) => (r.detail ? JSON.stringify(r.detail) : ""),
      cell: (r) => (
        <span className="line-clamp-1 text-xs text-muted-foreground">
          {r.detail && Object.keys(r.detail as object).length ? JSON.stringify(r.detail) : "—"}
        </span>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">Every admin action recorded on the practice, newest first.</p>
      <DataTable
        rows={rows}
        columns={columns}
        getRowId={(r) => r.id}
        loading={isPending}
        searchPlaceholder="Search activity"
        exportFileName="activity-log"
        emptyMessage="No activity recorded yet."
      />
    </div>
  );
}
